import React, { useEffect } from "react";
import classes from "./PaymentFailure.module.css";
import { useNavigate } from "react-router-dom";

const PaymentFailure = () => {

  const navigate = useNavigate()

  useEffect(()=>{
    const timeoutId = setTimeout(() => {
      navigate("/");
    }, 3000);

    // Cleanup function to clear the timeout when component unmounts
    return () => clearTimeout(timeoutId);
  },[])

  return (
    <div className={classes.container2}>
      <div className={`${classes.banner} bg-primary-100`}>
        <img className={classes.icon} src="/img/icons/pay-fail.svg" alt="payment-fail" />

        <h2 className="primary-700">Payment Failed!</h2>
      </div>
    </div>
  );
};

export default PaymentFailure;
